var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFaceSmileV2 = function SvgFaceSmileV2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 80 80"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#face-smile-v2_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#A3A3A3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "M40 70c16.569 0 30-13.431 30-30 0-16.568-13.431-30-30-30-16.568 0-30 13.432-30 30 0 16.569 13.432 30 30 30"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A3A3A3",
    d: "M28.75 36.875a3.125 3.125 0 1 0 0-6.25 3.125 3.125 0 0 0 0 6.25m22.5 0a3.125 3.125 0 1 0 0-6.25 3.125 3.125 0 0 0 0 6.25"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#A3A3A3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "M53 47.5a15.03 15.03 0 0 1-26 0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "face-smile-v2_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h80v80H0z"
  })))));
};
export default SvgFaceSmileV2;